<header class="potcasts_header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <img src="assets/images/logo.png" class="img-fluid" alt="logo" />
      </div>
    </div>
  </div>
</header>
